import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './HomeNutritionSections.css';
import productsData from '../data/products.json';
import { optimizeImage } from '../utils/imageOptimizer';



const ProductCard = ({ product }) => {
    const navigate = useNavigate();
    return (
        <div className="nutrition-card1" onClick={() => navigate(`/${product.type}-products/${product.id}`)}>
            <div className="card-img-wrapper">
                <img 
                    src={optimizeImage(product.img, { width: 300, height: 300 })} 
                    alt={product.name} 
                    className="card-img" 
                    loading="lazy"
                    width="300"
                    height="300"
                />
                {product.isComingSoon && (
                    <div className="coming-soon-label">Coming Soon</div>
                )}
                <div className="enquiry-hover-btn">
                    <span>View Details</span>
                </div>
            </div>
            <div className="card-info">
                <h3 className="card-title">{product.name}</h3>
                {!product.isComingSoon && <p className="card-price">{product.price}</p>}
            </div>
        </div>
    );
};


const HomeNutritionSections = () => {
    // const [latestIdx, setLatestIdx] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };
        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Filter some products for the sections
    const selectedIds = ['dog-1', 'dog-9', 'dog-27', 'dog-30', 'dog-38', 'cat-1', 'cat-9', 'dog-45'];
    const exploreProducts = selectedIds.map(id => productsData.find(p => p.id === id)).filter(Boolean);


    const latestProducts = productsData.filter(p => ['dog-46', 'dog-47', 'dog-48'].includes(p.id));

    /* const nextLatest = () => {
        setLatestIdx((prev) => (prev + 3) % latestProducts.length);
    };

    const prevLatest = () => {
        setLatestIdx((prev) => (prev - 3 + latestProducts.length) % latestProducts.length);
    }; */

    const puppyBg = isMobile 
        ? 'https://caninecrown.ascentbw.com/Image/Home/HomeMob.png'
        : 'https://caninecrown.ascentbw.com/Image/Home/Home.png';

    return (
        <div className="home-nutrition-container">
            {/* Section 1: Explore Nutrition */}
            <section className="explore-nutrition-section">
                <div className="section-container">
                    <div className="section-header">
                        <h2 className="hn-title">Explore Nutrition For Your Pet</h2>
                        <Link to="/dog-products" className="view-all-link">VIEW ALL PRODUCTS</Link>
                    </div>
                    <div className="nutrition-grid">
                        {exploreProducts.map(product => (
                            <ProductCard key={product.id} product={product} />
                        ))}
                    </div>
                </div>
            </section>

            {/* Section 2: Puppy Growth Formula */}
            <section className="puppy-formula-section">
                <div className="puppy-split">
                    {/* Left: Fixed background image */}
                    <div 
                        className="puppy-image-box"
                        style={{ backgroundImage: `url(${optimizeImage(puppyBg, { width: isMobile ? 768 : 1200 })})` }}
                    ></div>

                    {/* Right: Content */}
                    <div className="puppy-content-box">
                        <h2 className="puppy-title">Puppy Growth Formula</h2>
                        <p className="puppy-desc">
                            Scientifically formulated pet nutrition designed to support growth, strength, and overall wellbeing at every life stage.
                        </p>
                        <Link to="/dog-products" className="explore-all-link">EXPLORE ALL NUTRITION FOOD</Link>

                        <div className="formula-features-grid">
                            <div className="feature-item">
                                <div className="feature-icon-box">
                                    <img 
                                        src={optimizeImage("https://caninecrown.ascentbw.com/Image/Home/Bone.png", { width: 80, height: 80 })} 
                                        alt="Bone" 
                                        className="feature-icon-img" 
                                        loading="lazy"
                                        width="40"
                                        height="40"
                                    />
                                </div>
                                <p>Puppy Growth<br/>Formula</p>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon-box">
                                    <img 
                                        src={optimizeImage("https://caninecrown.ascentbw.com/Image/Home/Paw.png", { width: 80, height: 80 })} 
                                        alt="Paw" 
                                        className="feature-icon-img" 
                                        loading="lazy"
                                        width="40"
                                        height="40"
                                    />
                                </div>
                                <p>Adult Daily<br/>Nutrition</p>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon-box">
                                    <img 
                                        src={optimizeImage("https://caninecrown.ascentbw.com/Image/Home/Rin.png", { width: 80, height: 80 })} 
                                        alt="Energy" 
                                        className="feature-icon-img" 
                                        loading="lazy"
                                        width="40"
                                        height="40"
                                    />
                                </div>
                                <p>High Protein<br/>Performance</p>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon-box">
                                    <img 
                                        src={optimizeImage("https://caninecrown.ascentbw.com/Image/Home/Shield.png", { width: 80, height: 80 })} 
                                        alt="Shield" 
                                        className="feature-icon-img" 
                                        loading="lazy"
                                        width="40"
                                        height="40"
                                    />
                                </div>
                                <p>Special Care<br/>Nutrition</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 3: Latest Nutrition Formulas */}
            <section className="latest-formulas-section">
                <div className="section-container">
                    <div className="section-header">
                        <h2 className="hn-title">Coming Soon: Advanced Nutrition Range</h2>
                        {/* <div className="slider-nav">
                            <button onClick={prevLatest} className="nav-btn">PREVIOUS</button>
                            <span className="nav-sep">/</span>
                            <button onClick={nextLatest} className="nav-btn">NEXT</button>
                        </div> */}
                    </div>
                    <div className="nutrition-grid latest-grid">
                        {latestProducts.map(product => (
                            <ProductCard key={product.id} product={product} />
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomeNutritionSections;
